/**
 * A run's id for people to carry between screens: "Run …a1b2c3d4" with a Copy button. The same id is on the
 * workbench's run ledger, the audit trail and the exports (Agent 365, Sentinel), so searching Audit for it finds the rows.
 */

import { Copy } from '@gravity-ui/icons';
import { Button, Tooltip } from '@heroui/react';
import { useState } from 'react';

export const shortRunId = (runId: string): string => `Run …${runId.slice(-8)}`;

/** Copies a run id; an icon-only button, so it carries a tooltip. */
export function CopyRunIdButton({ runId, size = 'sm' }: { runId: string; size?: 'sm' | 'md' }) {
  const [done, setDone] = useState(false);
  const copy = () => {
    void navigator.clipboard?.writeText(runId).then(() => {
      setDone(true);
      setTimeout(() => setDone(false), 1500);
    });
  };
  return (
    <Tooltip delay={300}>
      <Button size={size} variant="ghost" isIconOnly aria-label="Copy run id" onPress={copy}>
        {done ? <span className="text-xs">Copied</span> : <Copy className="size-4" />}
      </Button>
      <Tooltip.Content>{done ? 'Copied' : 'Copy run id'}</Tooltip.Content>
    </Tooltip>
  );
}

/** The quiet label with its full id on hover and a Copy button. */
export function RunIdLabel({ runId }: { runId: string }) {
  return (
    <span className="inline-flex items-center gap-1 text-xs text-muted" title={runId}>
      <span className="mono tabular-nums">{shortRunId(runId)}</span>
      <CopyRunIdButton runId={runId} />
    </span>
  );
}
